require([
    "ShoppingCartIcon/miniCart"
],
function (miniCart) {
    miniCart.init();
});

define("ShoppingCartIcon/main", function(){});

